'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.StrukturiertesPromotionsprogrammSchema = {
  title: 'StrukturiertesPromotionsprogramm',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/strukturiertesPromotionsprogramm.js
// module id = +mt4
// module chunks = 0